//保存登录账户
export function setAccount(data){
    localStorage.setItem("account", data);
}

export function getAccount(){
    return localStorage.getItem("account");
}

export function clearAccount(){
    localStorage.removeItem("account");
}

//保存密码
export function setPassword(data){
    localStorage.setItem("password", data);
}

export function getPassword(){
    return localStorage.getItem("password");
}

export function clearPassword(){
    localStorage.removeItem("password");
}

//登录成功以后把服务端返回的几个对象缓存起来
export function setLoginResult(data){

    localStorage.setItem("userContext", JSON.stringify(data.userContext));
    localStorage.setItem("user", JSON.stringify(data.user));
    localStorage.setItem("rootOrganization", JSON.stringify(data.rootOrganization));
    localStorage.setItem("settings", JSON.stringify(data.settings));

    localStorage.setItem("token", data.userContext.token);
}

export function clearLoginResult(){
    localStorage.removeItem("userContext");
    localStorage.removeItem("user");
    localStorage.removeItem("rootOrganization");
    localStorage.removeItem("settings");
    
    localStorage.removeItem("token");

    localStorage.removeItem("password");
}

export function getToken(){
    return localStorage.getItem('token');
}

export function getUserId(){
    let user = getUser();
    return user.id;
}

export function getUserName(){
    let user = getUser();
    return user.name;
}

export function getOrganizationId(){
    let user = getUser();
    return user.organizationId;
}

export function getOrganizationName(){
    let user = getUser();
    return user.organizationName;
}

export function getRootOrganizationName(){
    let organization = getRootOrganization();
    return organization.name;
}

export function getUser(){
    return JSON.parse(localStorage.getItem('user'));
}

export function getUserContext(){
    return JSON.parse(localStorage.getItem('userContext'));
}

export function getRootOrganization(){
    return JSON.parse(localStorage.getItem('rootOrganization'));
}

export function getSettings(){
    return JSON.parse(localStorage.getItem('settings'));
}

export function updateSettings(data){
    localStorage.setItem("settings", JSON.stringify(data));
}

//needAuthorizaitonArray 中的任何一个满足都返回 true
export function checkAuthorizationAny(needAuthorizaitonArray){

    let user = getUser();

    if(user.domainAdmin)
        return true;

    let authorizationKeyArray = getAuthorizationKeyArray();

    // console.log("authorizationKeyArray:" + authorizationKeyArray);
    // console.log("needAuthorizaitonArray:" + needAuthorizaitonArray);

    var i;
    for (i in needAuthorizaitonArray)
    {
        if(authorizationKeyArray.indexOf(needAuthorizaitonArray[i]) >= 0)
        {
            return true;
        }
    }

    return false;
}

export function getAuthorizationKeyArray(){
    let user = getUser();
    let authorizationKeyArray = [];
    user.role.forEach(
    item=>{
        item.roleAuthorization.forEach(
            val=>{
                authorizationKeyArray.push(val.authorizationKey)
            })
        });

   authorizationKeyArray = [...new Set(authorizationKeyArray)];

   return authorizationKeyArray;

}

//保存当前日期信息
export function setDateTime(data){
    localStorage.setItem("dateTime", JSON.stringify(data));
}

export function getDateTime(){
    return JSON.parse(localStorage.getItem('dateTime'));
}



// WEBPACK FOOTER //
// ./src/utils/userContext.js